import { createFileRoute } from '@tanstack/react-router';
import { PortalGate } from '../../components/site/PortalGate';

export const Route = createFileRoute('/portal/')({
  component: PortalGate,
});
